import StandaloneAlbumCustomPrintConfigurator from './StandaloneAlbumCustomPrintConfigurator';

export default StandaloneAlbumCustomPrintConfigurator;
